<!--
 * @Descripttion: 
 * @version: v1.0.0
 * @Author: zhoumin
 * @Date: 2020-09-27 15:38:02
 * @LastEditors: zhoumin
 * @LastEditTime: 2020-09-27 15:54:44
-->
<template>
  <div class="RegistrationNotice">
    <h2>关于山西省第十四届职业院校技能大赛中等职业学校班主任能力大赛进行网上报名工作的通知</h2>
    <section>
      <object type="application/pdf" :data="url" id="review" style="width:100%;  height:900px;"></object>
    </section>
  </div>
</template>

<script>
export default {
  name: "RegistrationNotice",
  data() {
    return { url: "" };
  },
  created() {
    const name = "a6d5ea662d1246e9baee5983605405fe.pdf";

    this.$utils.getImgUrl(name).then(r => {
      this.url = r;
    });
  }
};
</script>

<style lang="scss" scoped>
.RegistrationNotice {
  h2 {
    text-align: center;
    font-size: 44px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 62px;
    color: rgba(235, 85, 79, 1);
    padding: 80px 0px 66px 0px;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }
  section {
    padding-bottom: 100px;
  }
}
</style>